import React from 'react';
import { ButtonPrimaryV2, icons, colors, colors2 } from "oolib";
import TagsSection from './TagsSection';
import { ImageInput } from '@/components/media/ImageInput';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { mediaQuery } from 'oolib';

// --- Styled Components (self-contained) ---

const Overlay = styled.div`
  z-index: 99998;
  position: fixed;
  inset: 0;
  background: ${colors.black_opacity80};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CaretButton = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 99999;
  ${({ side }) => side === 'left' ? 'left: 1rem;' : 'right: 1rem;'}
`;

const ModalContainer = styled.div`
  position: relative;
  background: ${colors2.white};
  border-radius: 8px;
  overflow: hidden;
  width: 90vw;
  max-height: 85vh;
  display: flex;
  flex-direction: column;

  ${mediaQuery('md')}{
    flex-direction: row;
  }
`;

const ActionButtons = styled.div`
  position: absolute;
  top: 0.8rem;
  right: 0.8rem;
  z-index: 10;
  display: flex;
  gap: 0.5rem;
`;

const ImageSection = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${colors.greyColor5};
  overflow: hidden;
  min-width: 0;
`;

const TagsSidebar = styled.div`
  width: 100%;
  max-height: 30vh;
  overflow-y: auto;
  background: ${colors.greyColor5};
  border-top: 1px solid ${colors2.grey10};
  padding: 1.5rem;

  ${mediaQuery('md')}{
    width: 280px;
    max-height: none;
    border-top: none;
    border-right: 1px solid ${colors2.grey10};
    order: -1;
  }
`;

// --- Component ---

const { CaretRight, CaretLeft } = icons;

const ImageModal = ({
  showModal,
  onClose,
  activeIndex,
  onPrevious,
  onNext,
  mediaCollection,
  allTpls,
  id
}) => {
  if (!showModal) return null;

  const someTagExists = (d) =>
    d.metaData?.contentType ||
    d.metaData?.subject?.data?.length > 0 ||
    d.metaData?.stakeholder?.data?.length > 0 ||
    !!d.metaData.facilityType === true ||
    d.metaData?.teams?.data?.length > 0;

  const activeItem = mediaCollection[activeIndex];
  const hasTags = someTagExists(activeItem);

  return (
    <Overlay>
      <CaretButton side="left" onClick={onPrevious}>
        <CaretLeft weight="duotone" size={75} color={colors.white} />
      </CaretButton>
      <CaretButton side="right" onClick={onNext}>
        <CaretRight weight="duotone" size={75} color={colors.white} />
      </CaretButton>

      <ModalContainer>
        <ActionButtons>
          <ButtonPrimaryV2
            icon="DownloadSimple"
            onClick={() => window.open(activeItem.mediaLink, "_blank")}
          />
          <ButtonPrimaryV2 icon="X" onClick={onClose} />
        </ActionButtons>

        {hasTags && (
          <TagsSidebar>
            <TagsSection activeItem={activeItem} allTpls={allTpls} />
          </TagsSidebar>
        )}

        <Link
          to={`/published-page/${activeItem.metaData.contentType}?id=${activeItem.id}`}
          style={{ flex: 1, display: 'flex', minWidth: 0 }}
        >
          <ImageSection>
            <div style={{ width: '100%' }}>
              <ImageInput
                id={id}
                readOnly
                value={[activeItem]}
              />
            </div>
          </ImageSection>
        </Link>
      </ModalContainer>
    </Overlay>
  );
};

export default ImageModal;